// Global Class for State Index Page
require(
  [
    'lazyLoad',
    'arrowHandler',
    'trackerHousingMarkets',
    'trackerSeoContent',
    'mapInitiator'
  ],
  (
    lazyLoad
  ) => {
    'use strict';

    const searchText = document.getElementById('SearchText');
    const searchOptions = document.getElementById('nhs_IndexSearchOptions');

    if (searchText && searchOptions) {
      searchText.addEventListener('click', () => {
        searchOptions.style.display = 'block';
      });
    }

    /**
          * Initializes the lazy load
        */
    lazyLoad.init();

    /**
        * Price Formatter
        */
    const priceFormatter = function (number) {
      if (typeof Intl === 'undefined') {
        return number;
      }
      const formatted = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0
      }).format(number);

      return formatted;
    };

    const priceLowValue = document.getElementById('PriceLow');

    if (priceLowValue) {
      priceLowValue.addEventListener('input', () => {
        const priceNumber = priceLowValue.value.replace(/\D/g, '');

        priceLowValue.value = priceNumber === '' ? '' : priceFormatter(parseInt(priceNumber, 10));

        if (priceNumber.length > 6) {
          priceLowValue.value = priceFormatter(parseInt(priceNumber.slice(0, 7), 10));
        }
      });
    }

    const priceHighValue = document.getElementById('PriceHigh');

    if (priceHighValue) {
      priceHighValue.addEventListener('input', () => {
        const priceNumber = priceHighValue.value.replace(/\D/g, '');

        priceHighValue.value = priceNumber === '' ? '' : priceFormatter(parseInt(priceNumber, 10));

        if (priceNumber.length > 6) {
          priceHighValue.value = priceFormatter(parseInt(priceNumber.slice(0, 7), 10));
        }
      });
    }

    new window.NewHomeSource.Modules.ArrowHandler({
      container: document.querySelector('[data-markets-container]')
    });

    const pinsElement = document.querySelector('[data-map-pins]');
    const pins = JSON.parse(pinsElement.innerHTML);

    const target = document.querySelector('[data-map-container]');

    function handleIntersection(entries, observer) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const configuration = {
            mapContainer: document.querySelector('[data-map-container]'),
            bundleName: 'stateIndexMapBundle',
            pins,
            // These coordinates are the geographic center of the United States
            center: {
              lat: 39.828175,
              lng: -98.5795,
            },
            zoom: 4
          };

          window.NewHomeSource.Map.MapInitiator(configuration);
          observer.disconnect();
        }
      });
    }

    const observer = new IntersectionObserver(handleIntersection);
    observer.observe(target);
  }
);

define("StateIndex", function(){});

